import { alpha, Backdrop, Stack } from "@mui/material";
import useWindowDimensions from "../../core/utils/UseWindowDimensions";
import { CustomCardView } from "./CustomCardView";
import { Rotate90DegreesCcwRounded } from "@mui/icons-material";
import { CustomTextView } from "./CustomTextView";
import { COLOR_BLACK, COLOR_MAIN, COLOR_WHITE } from "../../data/colors/Colors";
import { useTranslation } from "react-i18next";

export function PortraitOnlyContainer({
  children,
}: {
  children: React.ReactNode;
}) {
  const { width, height } = useWindowDimensions();
  const isMobile = width < 1200;
  const { t } = useTranslation();

  return (
    <Stack>
      {children}

      {isMobile && width > height && (
        <Backdrop
          open
          sx={{ zIndex: 9999, background: alpha(COLOR_BLACK, 0.5) }}
        >
          <Stack
            width={"100vw"}
            height={"100vh"}
            justifyContent={"center"}
            alignItems={"center"}
            position={"absolute"}
            left={0}
            right={0}
            top={0}
            bottom={0}
            bgcolor={COLOR_WHITE}
          >
            <CustomCardView
              background={COLOR_MAIN}
              children={
                <Stack alignItems={"center"} spacing={2} maxWidth={"60vw"}>
                  <Rotate90DegreesCcwRounded
                    fontSize="large"
                    sx={{ color: COLOR_WHITE, width: 60, height: 60 }}
                  />
                  <CustomTextView
                    text={t("rotate_device_vertically")}
                    fontWeight="bold"
                    textColor={COLOR_WHITE}
                    textAlign="center"
                    variant="h5"
                  />
                </Stack>
              }
            />
          </Stack>
        </Backdrop>
      )}
    </Stack>
  );
}
